import router from "../router";
import store from '../store'
import { Auth } from 'aws-amplify';

function verifyAuth(response) {
    response.catch(async (error) => { 
        if(error.response.status === 401) {
            try {
                let currentSession = await Auth.currentSession()
                store.commit('setToken',`Bearer ${currentSession.idToken.jwtToken}`)
                router.push('/dashboard')
            } catch(err){
                /* eslint-disable no-console */
                console.error(err);
                /* eslint-enable no-console */
                if(store.state.whitelabel.partner){
                    store.commit('setToken','') // Ensure embed will force the user to login again using magic link
                    router.push({
                        path: '/embed',
                        query: {
                          embedKey: store.state.whitelabel.apiKey,
                          userId: store.state.whitelabel.userId,
                          userEmail: store.state.whitelabel.userEmail,
                          context: store.state.whitelabel.context
                        }
                    })
                }else{
                    store.commit('clearData'); 
                    router.push('/'); // Go to login to re-authenticate´
                }
            }
        } 
    });  
    return response
}

export default verifyAuth